/**
 * Abschnitt „Mitmachen“: Mitmachen_Aktion (primär) (Req 6.2, 7.1).
 */

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useI18n } from "../../i18n/I18nProvider";
import { welcomeColors } from "./welcomeTheme";
import { JoinButton } from "./welcomeShared";

export default function JoinCta() {
  const { t } = useI18n();
  const theme = useTheme();
  const colors = welcomeColors(theme.palette.mode);

  return (
    <Container maxWidth="lg">
      <Box id="mitmachen" sx={{ pb: { xs: 8, md: 12 }, scrollMarginTop: 88 }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            // Dunkelmodus: neutraler Karten-Ton wie die anderen Boxen —
            // das grüne surfaceSoft wirkt dort nicht (kein echter Grünschimmer).
            bgcolor:
              theme.palette.mode === "dark"
                ? "background.paper"
                : colors.surfaceSoft,
            border: `1px solid ${colors.border}`,
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "8fr 4fr" },
              gap: 3,
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                variant="h2"
                component="h2"
                sx={{ fontSize: { xs: 28, md: 38 }, maxWidth: 620 }}
              >
                {t("welcome.join.title")}
              </Typography>
              <Typography
                sx={{ mt: 2, color: "text.secondary", fontSize: 17, lineHeight: 1.7 }}
              >
                {t("welcome.join.text")}
              </Typography>
            </Box>
            <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
              <Stack
                direction={{ xs: "column", sm: "row", md: "column" }}
                spacing={1.5}
                alignItems={{ xs: "flex-start", md: "flex-end" }}
              >
                <JoinButton labelKey="welcome.join.join" />
              </Stack>
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 1.5, color: "text.secondary" }}
              >
                {t("welcome.join.hint")}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
